/* Core & libraries */
import React, {useEffect, useState} from "react";
import { useTheme } from "react-jss";
import { FormattedMessage } from "react-intl";
import ReactPaginate from 'react-paginate';

/* Helpers, constants, custom methods, internal libraries */
import { ReactComponent as PrevIcon } from "../../../resources/images/prev-active.svg";
import { ReactComponent as PrevIconDisabled } from "../../../resources/images/prev-disabled.svg";
import { ReactComponent as NextIcon } from "../../../resources/images/next-active.svg";
import { ReactComponent as NextIconDisabled } from "../../../resources/images/next-disabled.svg";
import { useIsMobile } from "../../../hooks/useIsMobile";
import UCButton from "../../buttons";

/* Components */
/* Styles */
import styles from "./styles.js"

const Pagination = ({pagination, handlePageChange, data}) => {
  const theme = useTheme();
  const classes = styles({ theme });
  const isMobile = useIsMobile();

  const activePage = data?.pageNumber;
  const pageCount = data?.filterTotal < 10 ? 1 : data?.pagesAvailable;

  return (
    isMobile ?
      <div className={classes.mobilePagination}>
        <UCButton
          onClick={() => handlePageChange(activePage > 1 ? activePage - 1 : 1)}
          type="default"
          className={`${classes.mobilePrev} ${activePage === 1 ? "disabled" : ""}`}
          text={
            activePage === 1 ? <PrevIconDisabled /> : <PrevIcon />
          }
        />
        <div className={classes.paginationContent}>
          <FormattedMessage id="pagination.pageOf" values={{activePage, pageCount}} />
        </div>
        <UCButton
          onClick={() => handlePageChange(activePage < pageCount ? activePage + 1 : pageCount)}
          type="default"
          className={`${classes.mobileNext} ${activePage === pageCount ? "disabled" : ""}`}
          text={
            activePage === pageCount ? <NextIconDisabled /> : <NextIcon />
          }
        />
      </div>
    :
      <div className={classes.pagination}>
        <ReactPaginate
          initialPage={activePage - 1}
          breakLabel="..."
          nextLabel={
            <>
              <FormattedMessage id="pagination.next" />
              {
                activePage === pageCount ? <NextIconDisabled /> : <NextIcon />
              }
            </>
          }
          onPageChange={(event) => handlePageChange(event.selected + 1)}
          disableInitialCallback={true}
          pageCount={pageCount}
          pageRangeDisplayed={3}
          marginPagesDisplayed={pageCount > 7 ? 1 : 3}
          previousClassName={classes.prev}
          nextClassName={classes.next}
          previousLabel={
            <>
              {
                activePage === 1 ? <PrevIconDisabled /> : <PrevIcon />
              }
              <FormattedMessage id="pagination.prev" />
            </>
          }
          renderOnZeroPageCount={null}
        />
      </div>
  )
}

export default Pagination;
